import { InputAdornment, Stack, Typography } from "@mui/material";
import { CoreAutocomplete, CoreTextField } from "@verity/components/core";
import { CaretDownIcon } from "../assets";

type SingleAutocompleteOnChange = (event: React.SyntheticEvent, value: string) => void;

type FormAutoCompleteProps = {
	required?: boolean;
	title: string;
	placeholder: string;
	value: string | null;
	onChange: SingleAutocompleteOnChange;
	options: string[];
	startIcon?: React.ReactNode;
	optionIcons?: Record<string, React.ReactNode>;
	error?: string;
};

export function FormAutoComplete({
	required = false,
	title,
	placeholder,
	value,
	onChange,
	options,
	error,
	startIcon = null,
	optionIcons = {},
}: FormAutoCompleteProps) {
	return (
		<>
			<Typography>
				{title}
				{required && <span> *</span>}
			</Typography>
			<CoreAutocomplete
				popupIcon={<CaretDownIcon />}
				clearIcon={null}
				value={value}
				onChange={(e, v) => {
					if (typeof v !== "string") return;
					onChange(e, v);
				}}
				options={options}
				renderInput={(params) => (
					<CoreTextField
						placeholder={placeholder}
						{...params}
						InputProps={{
							...params.InputProps,
							...(startIcon && { startAdornment: <InputAdornment position="start">{startIcon}</InputAdornment> }),
						}}
						error={error}
					/>
				)}
				renderOption={(props, option) => (
					<li {...props} key={option}>
						<Stack direction="row" gap="10px">
							{optionIcons?.[option]}
							{option}
						</Stack>
					</li>
				)}
			/>
		</>
	);
}
